

<template>
  <div id="email-app" class="border border-solid d-theme-border-grey-light rounded relative overflow-hidden">
    <vs-sidebar
      class="items-no-padding"
      parent="#email-app"
      :click-not-close="clickNotClose"
      :hidden-background="clickNotClose"
      v-model="isEmailSidebarActive"
    >
      <user-profile
        :defaultSearchQuery="openMailGuestSearchQuery"
        :active="activeProfileSidebar"
        :conv-id="openMailId"
        conversationType="email"
        class="user-profile-container"
        @closeProfileSidebar="activeProfileSidebar = false"
      ></user-profile>

      <email-sidebar
        @closeSidebar="toggleEmailSidebar"
        :conversations="conversations"
        :filteredConversations="filteredConversations"
        :selectedCaseType.sync="selectedCaseType"
        :selectedTopics.sync="filterTopics"
        :filterVenue.sync="filterVenue"
        :filterAssigned.sync="filterAssigned"
        :filterStatus.sync="filterStatus"
        :isMuted.sync="isMuted"
      />
    </vs-sidebar>

    <div
      :class="{ 'sidebar-spacer': clickNotClose }"
      class="no-scroll-content border border-solid d-theme-border-grey-light border-r-0 border-t-0 border-b-0"
    >
      <!-- SEARCH BAR -->
      <div class="flex border d-theme-dark-bg items-center">
        <feather-icon
          class="md:inline-flex lg:hidden ml-4 mr-4 cursor-pointer"
          icon="MenuIcon"
          @click.stop="toggleEmailSidebar(true)"
        />
        <vs-input
          icon-no-border
          icon="icon-search"
          size="large"
          icon-pack="feather"
          placeholder="Search Mail"
          v-model="searchQuery"
          class="vs-input-no-border vs-input-no-shdow-focus w-full"
        />
      </div>

      <!-- EMAIL ACTION BAR -->
      <div
        class="
          email__actions
          flex
          items-center
          flex-wrap
          justify-between
          p-4
          border border-r-0 border-l-0 border-solid
          d-theme-border-grey-light
        "
      >
        <div class="flex items-center">
          <vs-checkbox
            v-model="selectAllCheckBox"
            icon-pack="feather"
            :icon="selectAllIcon"
            class="select-all-chexkbox ml-0"
            >Select All</vs-checkbox
          >
        </div>

        <div class="flex">
          <!-- <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
            <feather-icon icon="TagIcon" class="cursor-pointer ml-5" svg-classes="h-6 w-6"></feather-icon>

            <vs-dropdown-menu>
              <vs-dropdown-item
                v-for="(label, index) in emailTags"
                :key="index"
                @click="updateLabels(label.value)"
                class="whitespace-no-wrap"
              >
                <div class="h-3 w-3 inline-block rounded-full mr-3" :class="'bg-' + label.color"></div>
                <span>{{ label.text }}</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown> -->

          <vs-dropdown vs-trigger-click vs-custom-content class="cursor-pointer">
            <feather-icon icon="InfoIcon" class="ml-5 cursor-pointer" svg-classes="h-6 w-6" />
            <vs-dropdown-menu>
              <vs-dropdown-item @click="setStatusOnSelected('CLOSED')"> Close </vs-dropdown-item>
              <vs-dropdown-item @click="setStatusOnSelected('OPEN')"> Open </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>

          <GRUserSelector @onAssign="setAssignedOnSelected">
            <feather-icon
              icon="UserIcon"
              class="ml-5 cursor-pointer"
              svg-classes="h-6 w-6"
              @click="updateMarkUnread"
            />
          </GRUserSelector>

          <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
            <feather-icon icon="TagIcon" class="cursor-pointer ml-5" svg-classes="h-6 w-6"></feather-icon>

            <vs-dropdown-menu>
              <vs-dropdown-item
                v-for="(topic, index) in pickableTopics"
                :key="index"
                @click="addTopicToSelected(topic)"
                class="whitespace-no-wrap"
              >
                <div class="inline-block h-5">
                  <vs-chip :color="topic.color">
                    {{ topic.topic }}
                  </vs-chip>
                </div>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>
      </div>

      <!-- EMAILS LIST -->
      <component
        :is="scrollbarTag"
        class="email-content-scroll-area"
        :settings="settings"
        ref="mailListPS"
        :key="$vs.rtl"
      >
        <transition-group name="list-enter-up" class="email__mails" tag="ul" appear>
          <li
            class="cursor-pointer email__mail-item bg-white"
            v-for="(mail, index) in filteredConversations"
            :key="mail.id"
            @click="updateOpenMail(mail)"
            :style="{ transitionDelay: index * 0.1 + 's' }"
          >
            <mail-item
              :mail="mail"
              :isSelected="isMailSelected(mail.id)"
              @addToSelected="addToSelectedMails"
              @removeSelected="removeSelectedMail"
            />
          </li>
        </transition-group>
      </component>
    </div>

    <!-- EMAIL VIEW SIDEBAR -->
    <email-view
      :openMailId="openMailId"
      :isSidebarActive="isSidebarActive"
      @closeSidebar="closeMailViewSidebar"
      @showProfileSidebar="showProfileSidebar"
    >
    </email-view>
    <!-- <email-view
      :openMailId="openMailId"
      :isSidebarActive="isSidebarActive"
      @markUnread="updateSingleMarkUnread"
      @removeMail="removeOpenMail"
      @previousMail="previousMail"
      @nextMail="nextMail"
      @moveTo="moveCurrentTo"
      @closeSidebar="closeMailViewSidebar"
    >
    </email-view> -->
  </div>
</template>

<script>
import EmailSidebar from "./EmailSidebar.vue";
import GRUserSelector from "../Components/GRUserSelector.vue";
import MailItem from "./MailItem.vue";
import EmailView from "./EmailView.vue";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import { mapGetters } from "vuex";

import UserProfile from "../Components/UserProfileSidebar.vue";

import notificationSound from "@/assets/notification_sound.wav";

export default {
  data() {
    return {
      openMailId: null,
      selectedMails: [],
      isSidebarActive: false,
      showThread: false,
      clickNotClose: true,
      isEmailSidebarActive: true,
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.3,
      },

      activeProfileSidebar: false,
      userProfileId: -1,

      isMuted: false,

      openMailGuestSearchQuery: "",

      searchQuery: "",
      selectedCaseType: 0,
      filterVenue: null,
      filterAssigned: 0,
      filterStatus: 0,
      filterTopics: [],
      filterAssignedOptions: [
        { text: "Any", value: 0 },
        { text: "Unassigned", value: 1 },
        { text: "Assigned", value: 2 },
        { text: "Assigned to me", value: 3 },
      ],
      filterStatusOptions: [
        { text: "Any", value: 0 },
        { text: "OPEN", value: 1 },
        { text: "CLOSED", value: 2 },
      ],
      pickableTopics: [
        {
          color: "#ffb997",
          topic: "Important",
        },
        {
          color: "#f67e7d",
          topic: "Booking",
        },
        {
          color: "#843b62",
          topic: "Nightpay",
        },
        {
          color: "#0b032d",
          topic: "Feedback",
        },
        {
          color: "#44411a",
          topic: "Unrelated",
        },
      ],
    };
  },
  watch: {
    isSidebarActive(value) {
      if (!value) this.showThread = false;
    },
    windowWidth() {
      this.setSidebarWidth();
    },
    latestMessageNum() {
      if (!this.isMuted) this.playNotificationSound();
    },
  },
  computed: {
    ...mapGetters({
      conversations: "email/conversations",
      latestMessageNum: "email/latestMessageNum",
      userId: "users/userId",
    }),
    filteredConversations() {
      let result = this.conversations;
      // Venue
      if (this.filterVenue != null) result = result.filter(e => e.venueId === this.filterVenue);

      // Overall status (All, open, important, closed)
      if (this.selectedCaseType == 1) result = result.filter(e => e.isOpen);
      else if (this.selectedCaseType == 2)
        result = result.filter(e => e.topics.some(topic => topic.topic == "Important"));
      else if (this.selectedCaseType == 3) result = result.filter(e => !e.isOpen);

      // Assigned, Unassigned, Me
      if (this.filterAssigned == 1) result = result.filter(e => e.assignee === null);
      else if (this.filterAssigned == 2) result = result.filter(e => e.assignee !== null);
      else if (this.filterAssigned == 3)
        result = result.filter(e => e.assignee && e.assignee.userId === this.userId);

      // Topics
      if (this.filterTopics.length > 0)
        result = result.filter(e => e.topics.some(topic => this.filterTopics.includes(topic.topic)));

      // Search
      if (this.searchQuery != "")
        result = result.filter(e => {
          const qLower = this.searchQuery.toLowerCase();

          const nameMatch = e.guestEmailName.toLowerCase().includes(qLower);
          const messageMatch = e.messages.some(message =>
            message.text ? message.text.toLowerCase().includes(qLower) : false,
          );
          const topicMatch = e.topics.some(topic => topic.topic.toLowerCase().includes(qLower));

          return nameMatch || messageMatch || topicMatch;
        });

      // Sort by latest message timestamp and by status
      result.sort((a, b) => {
        const aMessage = this.lastMessage(a.id);
        const bMessage = this.lastMessage(b.id);

        if (a.status == "CLOSED" && b.status != "CLOSED") return 1;
        if (a.status != "CLOSED" && b.status == "CLOSED") return -1;
        return aMessage.timestamp < bMessage.timestamp ? 1 : -1;
      });

      return result;
    },

    lastMessage() {
      return convId => this.$store.getters["email/conversationLastMessage"](convId);
    },
    selectAllCheckBox: {
      get() {
        return this.selectedMails.length;
      },
      set(value) {
        value ? (this.selectedMails = this.conversations.map(mail => mail.id)) : (this.selectedMails = []);
      },
    },
    selectAllIcon() {
      return this.selectedMails.length === this.conversations.length ? "icon-check" : "icon-minus";
    },
    scrollbarTag() {
      return this.$store.getters.scrollbarTag;
    },
    isMailSelected() {
      return mailId => this.selectedMails.indexOf(mailId) !== -1;
    },
    windowWidth() {
      return this.$store.state.windowWidth;
    },
  },
  methods: {
    showProfileSidebar(guestProfileId) {
      console.log("SHOW SIDEBAR", guestProfileId);
      this.guestProfileId = guestProfileId;
      this.activeProfileSidebar = !this.activeProfileSidebar;
    },
    playNotificationSound() {
      var audio = new Audio(notificationSound);
      audio.play();
    },
    setStatusOnSelected(status) {
      this.selectedMails.forEach(conversationId => {
        console.log("Want to update status", status, conversationId);
        this.$store.dispatch(`email/setStatus`, {
          conversationId: conversationId,
          status: status,
        });
      });
    },
    addTopicToSelected(topic) {
      this.selectedMails.forEach(conversationId => {
        console.log("Want to add topic", topic, conversationId);
        this.$store.dispatch(`email/addTopic`, {
          conversationId: conversationId,
          conversationTopic: topic,
        });
      });
    },
    setAssignedOnSelected(userId) {
      this.selectedMails.forEach(conversationId => {
        console.log("Assigning", userId, conversationId);
        this.$store.dispatch(`email/setAssignee`, {
          conversationId: conversationId,
          assigneeId: userId,
        });
      });
    },
    updateOpenMail(mail) {
      this.openMailGuestSearchQuery = mail.guestEmailName ? mail.guestEmailName : mail.guestEmail;

      this.openMailId = mail.id;
      this.isSidebarActive = true;
    },
    addToSelectedMails(mailId) {
      if (this.selectedMails.indexOf(mailId) === -1) this.selectedMails.push(mailId);
    },
    removeSelectedMail(mailId) {
      const mailIndex = this.selectedMails.indexOf(mailId);
      if (mailIndex !== -1) this.selectedMails.splice(mailIndex, 1);
    },
    moveTo(to) {
      const payload = { emailIds: this.selectedMails, to };
      /*this.$store.dispatch("email/moveMailsTo", payload).catch((error) => {
        console.error(error);
      });*/
      this.selectedMails = [];
    },
    moveCurrentTo(to) {
      this.selectedMails = [this.openMailId];
      this.moveTo(to);
    },
    updateMarkUnread() {
      const payload = { emailIds: this.selectedMails, unreadFlag: true };
      //this.$store.dispatch("email/setUnread", payload);
      this.selectedMails = [];
    },
    removeOpenMail() {
      this.selectedMails = [this.openMailId];
      this.moveTo("trashed");
      this.isSidebarActive = false;
    },
    toggleIsStarred() {
      const payload = {
        mailId: this.currentMail.id,
        value: !this.currentMail.isStarred,
      };
      //this.$store.dispatch("email/toggleIsMailStarred", payload);
    },
    updateSingleMarkUnread() {
      this.selectedMails = [this.openMailId];
      this.updateMarkUnread();
      this.isSidebarActive = false;
    },
    updateLabels(label) {
      /*this.$store.dispatch("email/updateLabels", {
        mails: this.selectedMails,
        label,
      });*/
      this.selectedMails = [];
    },
    closeMailViewSidebar() {
      this.isSidebarActive = false;
    },
    setSidebarWidth() {
      if (this.windowWidth < 992) {
        this.isEmailSidebarActive = this.clickNotClose = false;
      } else {
        this.isEmailSidebarActive = this.clickNotClose = true;
      }
    },
    toggleEmailSidebar(value = false) {
      if (!value) {
        this.closeMailViewSidebar();
        if (this.clickNotClose) {
          return;
        }
      }
      this.isEmailSidebarActive = value;
    },
  },
  components: {
    MailItem,
    EmailSidebar,
    EmailView,
    VuePerfectScrollbar,
    GRUserSelector,
    UserProfile,
  },
  created() {
    this.setSidebarWidth();
  },
  beforeDestroy() {
    this.ws.close();
  },
  async mounted() {
    //this.$store.dispatch("chat/setChatSearchQuery", "");
    this.$vs.loading();
    await this.$store.dispatch("email/getAll");
    await this.$store.dispatch("venues/getGuestRelationUsers"); // Get all guest relation users that can be assigned

    if (!this.ws) {
      await this.$store.dispatch("email/negotiatePubSub");
      const wssUrl = this.$store.getters["email/pubSubUrl"];

      this.ws = new WebSocket(wssUrl);
      this.ws.onopen = () => console.log("Connected to Email PubSub server");

      this.ws.onclose = () => console.log("Disconnected from Email PubSub server");

      this.ws.onmessage = event => {
        this.$store.dispatch("email/handleSocketMessage", JSON.parse(event.data));
      };
    }

    this.$vs.loading.close();
  },
};
</script>


<style lang="scss">
@import "@/assets/scss/vuexy/apps/email.scss";
</style>
